export enum ModalForEnum {
  OrderMany,
  PayMany
}
